import { httpClient } from '@/shared/api/httpClient';
import { endpoints } from '@/shared/api/endpoints';
import type { LiveAnalyticsDto } from '@/shared/types/domain';

export const analyticsApi = {
  getLive: (eventId: string, signal?: AbortSignal) =>
    httpClient.get<LiveAnalyticsDto>(endpoints.analytics.live(eventId), signal),

  exportCsv: (eventId: string) => httpClient.downloadFile(endpoints.analytics.exportCsv(eventId)),
  exportXlsx: (eventId: string) => httpClient.downloadFile(endpoints.analytics.exportXlsx(eventId))
};
